import { daysInclusive, shiftDate, todayIn } from '@/lib/store-clock';

/**
 * Resolve a Sales Wave preset (Today / Yesterday / Last 7 Days / Custom)
 * into concrete API parameters. The previous implementation only returned
 * a `compareDate` for "yesterday" and dropped everything else on the
 * floor, which made the other presets purely cosmetic.
 *
 * "Today" is the store's day on `timeZone` (T18) — the zone the API buckets
 * the selected location (or, for all locations, the business) by.
 */
export function resolveSalesWaveParams(
  timeRange: {
    preset?: string;
    startDate?: string;
    endDate?: string;
  },
  timeZone: string,
  now: Date = new Date(),
): { date: string; compareDate?: string; days?: number } {
  if ('startDate' in timeRange && timeRange.startDate && timeRange.endDate) {
    const start = timeRange.startDate;
    const end = timeRange.endDate;
    const days = Math.max(1, daysInclusive(start, end));
    if (days <= 1) {
      return { date: end, compareDate: shiftDate(end, -1) };
    }
    return { date: end, days };
  }
  const today = todayIn(timeZone, now);
  switch (timeRange.preset) {
    case 'yesterday': {
      const y = shiftDate(today, -1);
      return { date: y, compareDate: shiftDate(y, -1) };
    }
    case 'last7':
      return { date: today, days: 7 };
    case 'today':
    default:
      return { date: today, compareDate: shiftDate(today, -1) };
  }
}
